// FILECONTENT_START src/common/components/DataGrid/DataGridToolbar.tsx
import { alpha } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { GridSelectionModel } from "@mui/x-data-grid-pro";
import { AxiosRequestConfig } from "axios";
import { ReactNode } from "react";
import Spacer from "../Spacer";
import { Options } from "./../../modules/helpers";
import Toolbar from "./../Toolbar";
import { DataGridFilterProps } from "./DataGrid";
import DataGridToolbarActions from "./DataGridToolbarActions";
import { GridRowsModel, TrashTypes } from "./useGrid";
import { UseEditToolbarProps } from "./useGridInlineEdit";

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme: any) =>
    createStyles({
      row: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
      },
      root: {
        padding: theme.spacing(1, 0.5, 0),
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
      },
      rootOnlyTrashed: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        //borderTopLeftRadius: 24,
        //borderTopRightRadius: 24,
        backgroundColor: alpha(theme.palette.warning.main, 0.2),
      },
      textField: {
        width: "auto",
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },
        margin: theme.spacing(1, 0.5, 1.5),
        "& .MuiSvgIcon-root": {
          marginRight: theme.spacing(0.5),
        },
        "& .MuiInput-underline:before": {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    }),
  { defaultTheme }
);
export type HeaderItemTypes = Array<
  | "filter"
  | "density"
  | "search"
  | "refresh"
  | "customFilter"
  | "customSettings"
  | "filterIndicator"
>;

export interface DataGridToolbarProps<F = any, O = any>
  extends UseEditToolbarProps {
  clearSearch?: () => void;
  onChange?: (evt: any) => void;
  value: string;
  applyFilter?: (item: any) => void;
  resetFilter?: Function;
  applySettings?: (item: any) => void;
  resetSettings?: Function;
  onCreate?: () => void;
  load?: () => void;
  deleteSelectedItems?: () => void;
  restoreSelectedItems?: () => void;
  editUrl?: string;
  canCreate?: boolean;
  canBatchActions?: boolean;
  canHandleTrash?: boolean;
  headerItems?: HeaderItemTypes;
  selectionState?: GridSelectionModel;
  trashType?: TrashTypes;
  setTrashType?: (trashType?: TrashTypes) => void;
  extraHeaderItem?: (rowsState?: GridRowsModel, filter?: any) => ReactNode;
  headerTitle?: (rowsState?: GridRowsModel) => ReactNode;
  rowsState?: GridRowsModel;
  options?: Options;
  buttonSize?: IconButtonProps["size"];
  loadOptions?: (
    requestConfig?: AxiosRequestConfig,
    component?: string
  ) => Promise<any>;
  renderFilter?: (props: DataGridFilterProps<F, O>) => ReactNode;
  renderSettings?: (props: DataGridFilterProps<F, O>) => ReactNode;
  filter?: any;
  settings?: any;
  wrapCellText?: boolean;
  autoColorFilterIndicator?: boolean;
  translationCategory?: string;
  optionComponent?: string;
  setWrapCellText?: (wrapCellText: boolean) => void;
  attributesNotCount?: string[];
  createTitle?: string;
  editTitle?: string;
  renderFilterIndicatorItem?: (props: {
    key: string;
    field: string;
    fieldName?: string;
    label?: string;
    color?: string;
    backgroundColor?: string;
    deleteItem: Function;
    option: any;
  }) => ReactNode;
}

export default function DataGridToolbar(props: DataGridToolbarProps) {
  const classes = useStyles();

  return (
    <Toolbar
      className={
        props.trashType === "onlyTrashed"
          ? classes.rootOnlyTrashed
          : classes.root
      }
    >
      <Spacer w={1} />
      <DataGridToolbarActions {...props} />
    </Toolbar>
  );
}

// FILECONTENT_END src/common/components/DataGrid/DataGridToolbar.tsx